function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#596266",
  d: "M6,4.9 L14,4.1 L14,2.1 L6,2.9 L6,4.9 Z M6,5.9 L6,13 C5.99198679,13.6150601 5.26964142,14.3242022 4.17003546,14.7216124 C2.84020069,15.2022299 1.46217152,15.0449129 1.09212116,14.370235 C0.722070791,13.6955571 1.50012978,12.7590052 2.82996454,12.2783876 C3.6071149,11.9975166 4.40072456,11.9345123 5,12.0653102 L5,3 L5,2 L15,1 L15,2 L15,11 C14.9919868,11.6150601 14.2696414,12.3242022 13.1700355,12.7216124 C11.8402007,13.2022299 10.4621715,13.0449129 10.0921212,12.370235 C9.72207079,11.6955571 10.5001298,10.7590052 11.8299645,10.2783876 C12.6071149,9.99751661 13.4007246,9.93451227 14,10.0653102 L14,5.1 L6,5.9 Z"
});

var SvgMusic = function SvgMusic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMusic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Music.00316fea.svg";
export { ForwardRef as ReactComponent };